// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-content-feedback-button-group {
  width: 800px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 5px;
  justify-content: flex-end;
}

.chat-content-feedback-button-group svg {
  color: #2895eb;
  height: 24px;
  width: 24px;
}

.chat-content-vote-up-button {
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
}

.chat-content-vote-down-button {
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
}

.chat-content-feedback-button {
  margin-left: 5px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s, border-color 0.3s;
  color: white;
  background-color: #2895eb;
  padding: 7px 20px;
  font-size: 12px;
  font-weight: 600;
  line-height: normal;
}

.chat-content-feedback-button:hover {
  background-color: #1886da;
}

.chat-feedback-modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 400px;
  background-color: white;
  border: 4px solid #2895eb;
  border-radius: 20px;
  box-shadow: 24;
  padding: 18px 24px;
}

.chat-feedback-title {
  font-size: 16px !important;
  font-weight: 600 !important;
}

.chat-feedback-desc {
  margin-top: 4px !important;
  font-size: 14px !important;
  color: #333 !important;
}

.chat-feedback-additional {
  margin-top: 8px;
  box-sizing: border-box;
  border: 1px solid #2895eb;
  border-radius: 10px;
  padding: 10px;
}

.chat-feedback-input {
  border: none;
  outline: none;
  resize: none;
  padding: unset;
  width: 100%;
  font-size: 14px;
  line-height: 16px;
  font-weight: 400;
  box-sizing: border-box;
}

.chat-feedback-input::-webkit-scrollbar {
  width: 6px;
}

.chat-feedback-input::-webkit-scrollbar-thumb {
  background-color: #a6a5a5;
  border-radius: 20px;
}

.chat-feedback-input::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

.chat-feedback-input::-webkit-scrollbar-corner {
  background-color: #f1f1f1;
}

.chat-content-feedback-submit-button {
  margin-left: 5px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s, border-color 0.3s;
  color: white;
  background-color: #2895eb;
  padding: 7px 20px;
  font-size: 12px;
  font-weight: 600;
  line-height: normal;
}

.chat-content-feedback-submit-button:hover {
  background-color: #1886da;
}

.chat-feedback-footer {
  margin-top: 8px;
  display: flex;
  justify-content: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/styles/components/chat/ChatFeedback.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gEAAgE;EAChE,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,cAAc;EACd,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gEAAgE;EAChE,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,yBAAyB;AAC3B","sourcesContent":[".chat-content-feedback-button-group {\n  width: 800px;\n  margin-top: 10px;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  justify-content: flex-end;\n}\n\n.chat-content-feedback-button-group svg {\n  color: #2895eb;\n  height: 24px;\n  width: 24px;\n}\n\n.chat-content-vote-up-button {\n  background: transparent;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n}\n\n.chat-content-vote-down-button {\n  background: transparent;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n}\n\n.chat-content-feedback-button {\n  margin-left: 5px;\n  border-radius: 5px;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.3s, color 0.3s, border-color 0.3s;\n  color: white;\n  background-color: #2895eb;\n  padding: 7px 20px;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: normal;\n}\n\n.chat-content-feedback-button:hover {\n  background-color: #1886da;\n}\n\n.chat-feedback-modal {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 400px;\n  background-color: white;\n  border: 4px solid #2895eb;\n  border-radius: 20px;\n  box-shadow: 24;\n  padding: 18px 24px;\n}\n\n.chat-feedback-title {\n  font-size: 16px !important;\n  font-weight: 600 !important;\n}\n\n.chat-feedback-desc {\n  margin-top: 4px !important;\n  font-size: 14px !important;\n  color: #333 !important;\n}\n\n.chat-feedback-additional {\n  margin-top: 8px;\n  box-sizing: border-box;\n  border: 1px solid #2895eb;\n  border-radius: 10px;\n  padding: 10px;\n}\n\n.chat-feedback-input {\n  border: none;\n  outline: none;\n  resize: none;\n  padding: unset;\n  width: 100%;\n  font-size: 14px;\n  line-height: 16px;\n  font-weight: 400;\n  box-sizing: border-box;\n}\n\n.chat-feedback-input::-webkit-scrollbar {\n  width: 6px;\n}\n\n.chat-feedback-input::-webkit-scrollbar-thumb {\n  background-color: #a6a5a5;\n  border-radius: 20px;\n}\n\n.chat-feedback-input::-webkit-scrollbar-track {\n  background-color: #f1f1f1;\n}\n\n.chat-feedback-input::-webkit-scrollbar-corner {\n  background-color: #f1f1f1;\n}\n\n.chat-content-feedback-submit-button {\n  margin-left: 5px;\n  border-radius: 5px;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.3s, color 0.3s, border-color 0.3s;\n  color: white;\n  background-color: #2895eb;\n  padding: 7px 20px;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: normal;\n}\n\n.chat-content-feedback-submit-button:hover {\n  background-color: #1886da;\n}\n\n.chat-feedback-footer {\n  margin-top: 8px;\n  display: flex;\n  justify-content: flex-end;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
